module.exports = __webpack_public_path__ + "static/img/sc_1@2x.c5a4071.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sc_1@2x.png
// module id = 3izX
// module chunks = 1